import { useNavigate } from "react-router-dom";
import clipboardQuestionIcon from "../../assets/images/clipboard-question.svg";
import type { JobStatus, JobType } from "../../interfaces/apiInterfaces/jobs";
import { JobStatusEnum, JobTypeEnum } from "../../interfaces/apiInterfaces/enums/job.enums";
import { useResources } from "../../hooks/useResources";

interface JobDetailsButtonProps {
  jobId: string;
  jobStatus: JobStatus;
  jobType: JobType;
}

const JobDetailsButton = ({ jobId, jobStatus, jobType }: JobDetailsButtonProps) => {
  const navigate = useNavigate();
  const { getResourceValue } = useResources();
  const isProcessing = jobStatus === JobStatusEnum.Processing;

  const handleClick = () => {
    if (!isProcessing) {
      if (jobType === JobTypeEnum.Update) {
        navigate(`/questions/update/${jobId}`);
      } else {
        navigate(`/jobs/${jobId}`);
      }
    }
  };

  return (
    <button 
      className={`job-details-btn ${isProcessing ? 'disabled' : ''}`} 
      onClick={handleClick}
      disabled={isProcessing}
    >
      <img src={clipboardQuestionIcon} alt="clipboard-question-icon" />
      <span>{getResourceValue("job_details", "Job Details")}</span>
    </button>
  );
};

export default JobDetailsButton;

